/**
 * @flow
 * @relayHash 59d218cad380cc4b98f486cee24f513a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeletePaymentModeMutationVariables = {|
  id: string
|};
export type DeletePaymentModeMutationResponse = {|
  +deletePaymentMode: {|
    +id: string
  |}
|};
export type DeletePaymentModeMutation = {|
  variables: DeletePaymentModeMutationVariables,
  response: DeletePaymentModeMutationResponse,
|};
*/


/*
mutation DeletePaymentModeMutation(
  $id: String!
) {
  deletePaymentMode(id: $id) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deletePaymentMode",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "PaymentModeModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeletePaymentModeMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeletePaymentModeMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeletePaymentModeMutation",
    "id": null,
    "text": "mutation DeletePaymentModeMutation(\n  $id: String!\n) {\n  deletePaymentMode(id: $id) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '962b5a9a15c264531613de1126033db5';
module.exports = node;
